/**
 * Service pages linked from the foot of every guide so a reader who wants to
 * know how the service works, what it costs, or who runs it has a one-click
 * route without hunting through the navbar. The static prerender reads this
 * list back out of this file (plugins/static-prerender.mjs), so the crawler
 * fallback and the React render can never list different pages.
 */
export const SERVICE_LINKS = [
  { to: "/how-it-works/", label: "How the service works" },
  { to: "/faqs/", label: "Service FAQs" },
  { to: "/reviews/", label: "Patient reviews" },
  { to: "/about-us/", label: "About Contraception Direct" },
];
